import { AdditionalAppointmentHints } from '@customTypes/Booking'
import { usePainDetailsContext } from '@context/PainDetailsContext'
import { questions } from '@dentalux/ui-library-core/custom/components/pain-details-form'
import { useUpsellContext } from '@context/UpsellContext'
import { isEmpty } from 'lodash'

const useAdditionalAppointmentHints = (): AdditionalAppointmentHints | undefined => {
  const { painDetails } = usePainDetailsContext()
  const { upsellInformation } = useUpsellContext()
  const hasPainInformation = painDetails && Object.values(painDetails).some((field) => Boolean(field))
  const additionalAppointmentHints: AdditionalAppointmentHints = {}

  if (hasPainInformation) {
    const painInformation = questions.reduce(
      (acc, current) =>
        painDetails[current.key]
          ? {
              ...acc,
              [current.key]: {
                questionContentfulKey: current.label,
                answerContentfulKey: current.answers.find((answer) => painDetails[current.key] === answer.value)?.label,
                answerValue: painDetails[current.key],
              },
            }
          : acc,
      {}
    )

    additionalAppointmentHints.painInformation = painInformation
  }

  if (upsellInformation) {
    additionalAppointmentHints.upsellInformation = upsellInformation
  }

  return isEmpty(additionalAppointmentHints) ? undefined : additionalAppointmentHints
}

export default useAdditionalAppointmentHints
